
export class updateMnemonic {
    static readonly type = '[mnemonicUpdate] mnemonicUpdate';

    constructor(public payload: string) {
    }
}